import InfoPreview from "@common/controls/InfoPreview/component";
import { InlinePreloader } from "@common/controls/Preloader/component";
import { useI18n } from "@common/hooks/i18n";
import { usePromise } from "@common/lib/hooks";
import { type Account } from "@common/modules/account/types";
import React from "react";
import { type LookupAccount } from "../../types";

type Props = {
  account: Account.Api.LookupAccount;
  style?: React.CSSProperties;
};
const WalletRecipientPreview = (props: Props) => {
  const i18n = useI18n();

  return (
    <InfoPreview style={props.style}>
      <InfoPreview.Line label={i18n.accountHolder} value={props.account.accountHolder} />
      <InfoPreview.Line label={i18n.accountNumber} value={props.account.accountNumber} />
      <InfoPreview.Line label={i18n.currency} value={props.account.currencyCode} />
    </InfoPreview>
  );
};
export default WalletRecipientPreview;

type DynamicProps = {
  accountNumber: string;
  lookupAccount: LookupAccount;
  style?: React.CSSProperties;
};
export const WalletRecipientPreviewDynamic = (props: DynamicProps) => {
  const [account, isLoading] = usePromise({
    fn: props.lookupAccount,
    args: [props.accountNumber],
    shouldLoad: true
  });

  if (isLoading) return <InlinePreloader />;
  if (!account) return null;

  return <WalletRecipientPreview account={account} style={props.style} />;
};
